import ReactECharts from "echarts-for-react";

const colors = [
  "#3E2723",
  "#5D4037",
  "#795548",
  "#8D6E63",
  "#A1887F",
  "#BCAAA4",
  "#D7CCC8",
  "#EFEBE9",
];
const CategoryChart = ({ data = [] }) => {

  const chartData = data.map((item) => ({
    name: item.categoryName,
    value: item.productCount,
  }));

  const option = {
    color: colors,

    tooltip: {
      trigger: "item",
      formatter: "{b}<br/>Products : {c} ({d}%)",
    },

    legend: {
      orient: "vertical",
      left: 10,
      top: "middle",
      icon: "circle",

      formatter(name) {
        const item = chartData.find((i) => i.name === name);
        return `{name|${name}} {value|${item?.value ?? 0}}`;
      },

      textStyle: {
        rich: {
          name: {
            width: 180,
            fontSize: 14,
          },
          value: {
            width: 35,
            align: "right",
            fontWeight: "bold",
          },
        },
      },
    },

    series: [
      {
        type: "pie",
        radius: "70%",
        center: ["75%", "50%"],
        label: { show: false },
        data: chartData,
      },
    ],
  };

  return (
    <>
      <h3 className="fw-bold mb-3">Category Wise Products</h3>

      <ReactECharts
        option={option}
        style={{ width: "100%", height: "380px" }}
      />
    </>
  );
};

export default CategoryChart;